export default __webpack_public_path__ + "static/media/794.ce108c2f.gif";